<template>
  <div class="wizard__container">
    <img src="~@/assets/img/99icon_black.svg" alt="99 Empresas" class="wizard__logo">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Container',
  data () {
    return {
      namespace: 'Views.Wizard'
    }
  }
}
</script>

<style lang="scss">
.wizard__container {
  background-color: #fff;
  border: solid 1px #f0f0f0;
  border-radius: 4px;
  margin: 0 auto;
  max-width: 848px;
  padding: 68px 0 40px;
  position: relative;

  @media (min-width: 992px) {
    min-height: 601px;
  }
}

.wizard__logo {
  left: 50%;
  position: absolute;
  top: -28px;
  transform: translateX(-50%);
  width: 48px;
}
</style>
